<template>
    <div class="col-12">
        <div class="tablet-contract-header">
            <div class="small fw-bold" v-html="contractName(contract)" />
        </div>
        <div class="tablet-contract-wrapper">
            <div class="tablet-contract-card-image d-flex align-items-center">
                <img
                    v-if="contract.imageDevice"
                    :src="contract.imageDevice.src"
                    :alt="contract.imageDevice.alt"
                    :class="['h-100' , !contract.descriptionDevice ? 'w-75' : 'w-100']"
                >
                <span v-else class="icon icon-device-smart-phone" aria-hidden="true" />
            </div>
            <ob1-cards
                :is-multiple="true"
                :with-composite-link="false"
                class="d-flex flex-row flex-wrap tablet-contract-card bg-white py-1 px-1"
            >
                <div v-if="contract.withDroMessage" class="alert-wrapper">
                    <zone-contracts-alert
                        :message="contract.labels.droMessage"
                        :link-url="contract.changeDeviceLinkUrl"
                    />
                </div>
                <div class="pe-1 tablet-contract-card-item">
                    <div class="title-big fw-bold">
                        {{ contract.labels.changeDeviceLabel }}
                    </div>
                    <ul class="items-list row">
                        <li class="col-12">
                            <a
                                :href="contract.changeDeviceLinkUrl"
                                class="items-list-item"
                                :data-oevent-category="contract.tmsChangeDevice.tagZone + (index + 1)"
                                :data-oevent-action="contract.tmsChangeDevice.tagName"
                                :data-oevent-label="contract.changeDeviceLinkUrl"
                            >
                                <div class="item-container no-border-bottom">
                                    <div class="item-text">
                                        <span>{{ contract.descriptionDevice }}</span>
                                        <small class="item-desc">{{ contract.labels.changeDeviceText }}</small>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="px-1 tablet-contract-card-item">
                    <div class="title-big fw-bold">
                        {{ contract.labels.changeOfferLabel }}
                    </div>
                    <ul class="items-list row">
                        <li class="col-12">
                            <a
                                :href="contract.changeOfferLinkUrl"
                                class="items-list-item"
                                :data-oevent-category="contract.tmsChangeOffer.tagZone + (index + 1)"
                                :data-oevent-action="contract.tmsChangeOffer.tagName"
                                :data-oevent-label="contract.changeOfferLinkUrl"
                            >
                                <div class="item-container no-border-bottom">
                                    <div class="item-text">
                                        <span>{{ contract.mainOfferLabel }}</span>
                                        <small class="item-desc">{{ contract.labels.changeOfferText }}</small>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="ps-1 tablet-contract-card-item">
                    <div class="standard text-gray3 py-0 fw-bold">
                        {{ contract.labels.manageOfferLabel }}
                    </div>
                    <ob1-liens
                        class="pb-0"
                        :text="contract.labels.manageOfferLink1"
                        :href="contract.manageOfferLink1Url"
                        with-arrow
                        :data-oevent-category="contract.tmsManageOffer1.tagZone + (index + 1)"
                        :data-oevent-action="contract.tmsManageOffer1.tagName"
                        :data-oevent-label="contract.manageOfferLink1Url"
                    />
                    <ob1-liens
                        :text="contract.labels.manageOfferLink2"
                        :href="contract.manageOfferLink2Url"
                        with-arrow
                        :data-oevent-category="contract.tmsManageOffer2.tagZone + (index + 1)"
                        :data-oevent-action="contract.tmsManageOffer2.tagName"
                        :data-oevent-label="contract.manageOfferLink2Url"
                    />
                </div>
            </ob1-cards>
        </div>
    </div>
</template>
<script>

import ZoneContractsAlert from "./ZoneContractsAlert.vue";

export default {
    components: {ZoneContractsAlert},
    props: {
        contract: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    },
    methods: {
        contractName(contract) {
            let msisdn = PhoneFormatter.toFrench(contract.msisdn)
            if (contract.firstName)
                return 'Pour ' + contract.firstName + '<br>' + contract.mainOfferLabel + ' / ' + msisdn
            else return 'Pour la ligne' + contract.firstName + '<br>' + contract.mainOfferLabel + ' / ' + msisdn
        },
    },
}
</script>

<style scoped lang="scss">
@import 'ob1_variables';

.tablet-contract-header {
    background: none;
    margin-bottom: 5px;
    padding: 0 0 0 72px;
    border-radius: 32px;
    display: inline-flex;
}

.tablet-contract-card-item {
    flex: 1;
    z-index: 2;
}

.tablet-contract-wrapper {
    position: relative;
}

.tablet-contract-card-image {
    left: -5px;
    top: 0;
    transform: translateY(-50%);
    width: 100px;
    z-index: -1;
    height: calc(100% - 5px);
    position: absolute;
}

.tablet-contract-card-image img {
    max-height: 140px;
    object-fit: contain;
}

.tablet-contract-card-image .icon {
    font-size: 84px;
}

.alert-wrapper {
    flex-basis: 100%;
}

.title-big {
    font-size: 1rem
}

</style>
